/**
 * Product display branding — single source of truth for user-facing copy.
 * Technical identifiers (package name, storage keys, backup source) stay
 * on the `clinic-ms` slug and are intentionally separate.
 */
export const PRODUCT_NAME = 'Roseth MS' as const

/** Short product description used in document metadata. */
export const PRODUCT_DESCRIPTION =
  'Modern clinic and patient management dashboard' as const
